import { WorklistToolTemplateContentsInput } from "graphql/generated/schema-types";
import { Twelve24TCToolState } from "../../state";
import { ITwelve24TCMethodSettings } from "../../state/initial-state";

export const getDeadPlateInfoForTemplate = (
  twelve24TCState: Twelve24TCToolState,
) => {
  return twelve24TCState.deadPlateType
    ? [
        {
          plateType: "Dead",
          plateIndex: 0,
          labwareTypeCode: twelve24TCState.deadPlateType,
          numberOfRows: 0,
          numberOfColumns: 0,
        },
      ]
    : [];
};

export const getSourcePlateInfoForTemplate = (
  twelve24TCState: Twelve24TCToolState,
) => {
  return twelve24TCState.sourcePlateInfo
    .filter((e) => e.labwareTypeCode !== "")
    .map((item, index) => {
      return {
        plateType: "Source",
        plateIndex: index,
        labwareTypeCode: item.labwareTypeCode,
        numberOfRows: item.rows.length,
        numberOfColumns: item.cols.length,
        operatingVol: item.operatingVol,
        discardSourcePlate: item.discardSourcePlate,
      };
    });
};

export const getDestPlateInfoForTemplate = (
  twelve24TCState: Twelve24TCToolState,
) => {
  return twelve24TCState.destPlateInfo
    ? [
        {
          plateType: "Dest",
          plateIndex: 0,
          labwareTypeCode: twelve24TCState.destPlateInfo.labwareTypeCode,
          numberOfRows: twelve24TCState.destPlateInfo.rows.length,
          numberOfColumns: twelve24TCState.destPlateInfo.cols.length,
          operatingVol: twelve24TCState.destPlateInfo.operatingVol,
          startingVol: twelve24TCState.destPlateInfo.startingVol,
          preprocess: twelve24TCState.destPlateInfo.preprocess,
          topUpVol: twelve24TCState.destPlateInfo.topupVol,
          minOperatingVol: twelve24TCState.destPlateInfo.minOperatingVol,
          destPlateCode: twelve24TCState.destPlateInfo.plateCode,
        },
      ]
    : [];
};

export const getHarvestWellsTemplate = (
  twelve24TCState: Twelve24TCToolState,
) => {
  return twelve24TCState.worklistValues.harvestWells
    .map((row) => ({
      task: "HarvestWells",
      details: "",
      aspirateVol: "",
      dispenseVol: "",
      transferVol: "",
      sourcePlateType:
        twelve24TCState.sourcePlateInfo[row.sourcePlateIndex].labwareTypeCode,
      sourcePlatePosition: row.sourcePlateIndex,
      sourceWellID: row.sourceWellId,
      destinationPlateType: twelve24TCState.destPlateInfo.labwareTypeCode,
      destinationPlatePosition: row.destPlateIndex,
      destinationWellID: row.destWellId,
    }))
    .filter((e) => e.destinationPlateType !== "");
};
export const buildDeadTotalPlateWorklistTemplate = (
  methodSettings: ITwelve24TCMethodSettings,
) => {
  const worklist: WorklistToolTemplateContentsInput[] = [];

  worklist.push({
    task: "DeadTotalPlate",
    details: `CountPreSpin|${methodSettings.deadTotalCountSpinOrder ?? ""};`,
    aspirateVol: "",
    dispenseVol: "",
    transferVol: methodSettings.aliquotVolume.toString(),
    sourcePlateType: "",
    sourcePlatePosition: null,
    sourceWellID: "",
    destinationPlateType: "",
    destinationPlatePosition: null,
    destinationWellID: "",
  });

  return worklist;
};

export const buildAdditionalMethodSettingsTemplate = (
  methodSettings: ITwelve24TCMethodSettings,
) => {
  const worklist: WorklistToolTemplateContentsInput[] = [];

  worklist.push({
    task: "DefaultVSpinSettings",
    details: `${+!!methodSettings.defaultVSpinSettings}`,
    aspirateVol: "",
    dispenseVol: "",
    transferVol: "",
    sourcePlateType: "",
    sourcePlatePosition: null,
    sourceWellID: "",
    destinationPlateType: "",
    destinationPlatePosition: null,
    destinationWellID: "",
  });

  return worklist;
};
